import { combineReducers } from 'redux';
import authReducer from '../slices/authSlice'; // Import your auth slice reducer

const rootReducer = combineReducers({
  auth: authReducer,
  // Add other reducers if needed
});

export default rootReducer;
